/* eslint-disable import/prefer-default-export */
import { TRACK_SESSION_STARTED } from './types';

export function trackSessionStarted() {
  return (dispatch) =>
    dispatch({
      type: TRACK_SESSION_STARTED,
      payload: {
        name: 'Session started',
        properties: {},
      },
    });
}
